import { render, staticRenderFns } from "./ReferralHeader.vue?vue&type=template&id=c3adecb4&scoped=true"
import script from "./ReferralHeader.vue?vue&type=script&lang=js"
export * from "./ReferralHeader.vue?vue&type=script&lang=js"
import style0 from "./ReferralHeader.vue?vue&type=style&index=0&id=c3adecb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3adecb4",
  null
  
)

export default component.exports